import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import {
	selectMerchandiseById,
	selectShowCheckout,
	setShowCheckout,
	insertNewOrder,
	clearCart,
} from '../merchandiseSlice'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import {selectAcceptedCurrency} from '../../../settings/settingsSlice'
import {envAwarePost} from '../../../../util/util'
import {useCart} from '../../hooks'

import {
	setMultiFormsModal
} from '../../../../state/customFormsSlice'

const getPaymentIntent = (items)=>(
	envAwarePost(
		'api/merchandise/',
		{action:'getPaymentIntent',items}
	)
)

const finalizePaymentIntent = (payment_intent_id) => envAwarePost(
	'api/merchandise/',
	{action:'finalizePaymentIntent',payment_intent_id}
)

const PurchaseModal = ()=>{
	const stripe = useStripe()
	const elements = useElements()
	const dispatch = useDispatch()

	const onHide = ()=>{
		dispatch(setShowCheckout(false))
		dispatch(clearCart())
	}

	const [status,setStatus] = useState('idle')
	const acceptedCurrency = useSelector(selectAcceptedCurrency)
	const show = useSelector(selectShowCheckout)

	const {grandTotal,hasItems,itemsQtyMap,forms} = useCart()

	const forwardToForms = (forms) => {
		//assign the forms to the client then forward to 
		//the modal for them to fill out the newly assigned forms
		envAwarePost('api/customForms/',{
			action:'addFormsToClient',
			form_ids:forms.map(form=>form.id),
		}).then(()=>{
			dispatch(setMultiFormsModal({
				show:true,
				programs:[],
				forms
			}))
		})
	}

	const confirmPayment = () => stripe.confirmPayment({
		elements,
		confirmParams: {
			return_url: 'https://www.fitsw.com',
		},
		redirect:'if_required'
	})

	const handleCheckout = async event =>{
		setStatus('pending')
		// Block native form submission.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		confirmPayment()
		.then( res => {
			if(res.error) throw new Error(res.error.message)
			if(res.paymentIntent.status !== 'succeeded') throw new Error("Something went wrong. Please, try again")
			return finalizePaymentIntent(res.paymentIntent.id)
		}).then( res => {
			if( res.success === '1' ){
				window.alert('Your order has been successfully placed. Check the orders tab.')
				if (forms.length>0) forwardToForms(forms)
				return dispatch(insertNewOrder(res.data.order))
			}else{
				throw new Error(res.message)
			}
		}).then( res => {
			onHide()
			setStatus('idle')
		}).catch( err => {
			setStatus('idle')
			window.alert(err)
		})

	}

	if(!hasItems) return null
	return (
		<Modal 
			onHide={onHide}
			show={show}
			centered
		>
			<Modal.Header>
				Checkout
			</Modal.Header>
			<Modal.Body>
				<PaymentElement/>
				<div className="text-right mt-2">
					<Button 
						disabled={status==='pending'}
						onClick={handleCheckout} 
						variant="outline-success" 
						size="sm"
					>
						{
							status === 'pending'
							? <span>
								Processing Payment
								<Spinner className="ml-1" animation="border" size="sm"/>
							</span>
							: `Pay ${String.fromCharCode(acceptedCurrency.char_code)}${grandTotal.toFixed(2)} (${acceptedCurrency.ISO})`
						}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default PurchaseModal